import moment from 'moment';

export const millisecondsToMinutes = input =>
  moment.duration(input).format('m:ss', {
    trim: false,
  });

export const millisecondsToMinutesDecimal = input =>
  Math.round(moment.duration(input).asMinutes() * 100) / 100;
